module.exports = __webpack_public_path__ + "images/emoji/grin.417f947f4c8632e69c22.png";